<nz-table
  #basicTable
  [nzData]="uploadList"
  nzSize="middle"
  class="file-list-table"
  [nzFrontPagination]="false"
  [hidden]="!uploadList.length"
>
  <thead>
    <tr>
      <th *ngIf="showProgress"></th>
      <th>{{ translatePaths.queue + 'object' | transloco }}</th>
      <th>{{ translatePaths.queue + 'folder' | transloco }}</th>
      <th>{{ translatePaths.queue + 'fileSize' | transloco }}</th>
      <th>{{ translatePaths.queue + 'filename' | transloco }}</th>
      <th></th>
    </tr>
  </thead>
  <tbody>
    <tr
      *ngFor="let uploadFile of basicTable.data"
      (mouseover)="hoveredItem = uploadFile"
      (mouseleave)="hoveredItem = null"
    >
      <td *ngIf="showProgress">
        <div class="icon-wrap">
          <nz-progress
            nzType="circle"
            [nzPercent]="uploadFile.file.percent"
            [nzWidth]="20"
            [nzStatus]="uploadFile.file.status === 'error' && 'exception'"
            [nzFormat]="uploadFile.file.status === 'uploading' ? format : null"
            *ngIf="!uploadFile.isCancelled"
          ></nz-progress>
          <i
            *ngIf="uploadFile.isCancelled"
            nz-icon
            [nzType]="'stop'"
            [nzTheme]="'twotone'"
            [nzTwotoneColor]="'#ff3d3d'"
          ></i>
        </div>
      </td>
      <td>
        {{ 'section.' + uploadFile.uploadZone.uploadEntity.type | transloco }}
        {{ 'id' | transloco }}
        {{ uploadFile.uploadZone.uploadEntity.id }}
      </td>
      <td>
        {{
          translatePaths.uploadZone + uploadFile.uploadZone.namePath | transloco
        }}
      </td>
      <td class="filesize">{{ uploadFile.file.size | fileSize }}</td>
      <td class="filename">
        <div class="filename-wrap">
          <p>{{ uploadFile.file.name }}</p>
          <div
            *ngIf="hoveredItem === uploadFile && uploadFile.message"
            class="message"
          >
            {{ translatePaths.messages + uploadFile.message | transloco }}
          </div>
        </div>
      </td>
      <td>
        <div class="icon-wrap">
          <i
            *ngIf="uploadFile.file.status === 'done'"
            (click)="view(uploadFile)"
            nz-icon
            nzType="eye"
          ></i>
          <i
            *ngIf="showDeleteFileButton(uploadFile)"
            (click)="removeItem(uploadFile)"
            nz-icon
            nzType="close"
          ></i>
          <i
            *ngIf="uploadFile.isCancelled"
            (click)="reUpload(uploadFile)"
            nz-icon
            nzType="redo"
          ></i>
        </div>
      </td>
    </tr>
  </tbody>
</nz-table>
